import type { OrganizationSettings } from '@eye-able/types';

/**
 * Route paths hidden from the navigation bar for the whole organisation,
 * covering both top-level entries and sub-items inside collapsible sections.
 *
 * Read from the organisation settings JSON (`hiddenNavigationItems`), which is
 * delivered to the frontend on the user object (`user.settings`). The list is
 * maintained manually in the organisation settings and is purely visual —
 * route access itself is not restricted.
 */
export function getHiddenNavigationItems(user: unknown): string[] {
  const settingsJson = (user as { settings?: unknown } | null | undefined)
    ?.settings;
  if (typeof settingsJson !== 'string' || settingsJson.length === 0) {
    return [];
  }

  try {
    const settings: OrganizationSettings = JSON.parse(settingsJson);
    if (!Array.isArray(settings?.hiddenNavigationItems)) {
      return [];
    }
    return settings.hiddenNavigationItems.filter(
      (path): path is string => typeof path === 'string',
    );
  } catch {
    return [];
  }
}
